import { ACCREDITATIONS } from "../lib/site";

export const AccreditationsMarquee = () => {
  const items = [...ACCREDITATIONS, ...ACCREDITATIONS]; // doubled for seamless loop

  return (
    <section data-testid="accreditations" className="relative py-12 border-y border-white/10 bg-ink-900/60">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 mb-7">
        <div className="flex items-center justify-between">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-cyan-400">
            ⟶ SIA Approved · Constructionline Gold · Trusted UK-Wide
          </p>
          <p className="hidden sm:block text-xs text-slate-500 font-mono">SIA · SSIP · Achilles · UVDB · ICO</p>
        </div>
      </div>

      <div className="marquee-wrap">
        <div className="flex gap-12 animate-marquee items-center" style={{ width: 'max-content' }}>
          {items.map((a, idx) => (
            <div
              key={`${a.name}-${idx}`}
              data-testid={`accred-${idx}`}
              className="shrink-0 w-28 h-28 rounded-lg bg-white/95 border border-white/10 p-4 flex items-center justify-center"
            >
              <img src={a.logo} alt={a.name} className="max-w-full max-h-full object-contain" loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
